import { useMemo, useState } from "react";

import { Autocomplete } from "@aclymatepackages/atoms";
import { productCategories } from "@aclymatepackages/lists";

const ProductCategories = ({
  multiple = false,
  setValue,
  value,
  ...otherProps
}) => {
  const [inputValue, setInputValue] = useState("");

  // Build options with guaranteed id and name, and sort by name
  const options = useMemo(() => {
    return (productCategories || [])
      .map((pg) => ({
        id: pg.id ?? String(pg.label ?? pg),
        name: pg.label ?? String(pg.id ?? pg),
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, []);

  const renderOption = (props, option) => {
    return (
      <li {...props} key={option.id}>
        {option?.name}
      </li>
    );
  };

  // Map incoming value (id or array of ids) to option object(s) expected by Autocomplete
  const selectedValue = multiple
    ? Array.isArray(value)
      ? options.filter((o) => value.includes(o.id))
      : []
    : options.find((o) => o.id === value) || null;

  const handleChange = (event, newValue) => {
    if (multiple) {
      const ids = Array.isArray(newValue) ? newValue.map((v) => v.id) : [];
      return setValue(ids);
    }

    return setValue(newValue ? newValue.id : null);
  };

  return (
    <Autocomplete
      label="Select a product category"
      availableOptions={options}
      multiple={multiple}
      renderOption={renderOption}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
      value={selectedValue}
      onChange={handleChange}
      {...otherProps}
    />
  );
};
export default ProductCategories;
